import React, { useState } from "react";

import clsx from "clsx";

/* Material UI */
import {
  Accordion,
  AccordionSummary,
  Typography,
  Grid,
  Button,
} from "@material-ui/core";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PropTypes from "prop-types";

/* Style */
import { useStyles } from "../styles";

import ValetAreaPayLaterSettings from "../ValetAreaPayLaterSettings/ValetAreaPayLaterSettings";
import TicketFieldService from "../../../../services/TicketFieldService";
import apiClient from "../../../../auth/apiClient";

const ticketFieldService = new TicketFieldService(apiClient);

const TicketFieldsSettingsForm = ({
  requestType,
  onTicketFieldsButtonClicked,
  entityID,
  settingValues,
  showPayLaterToggle,
  onPayLaterChanged,
}) => {

  const requestName = ticketFieldService.getRequestName(requestType);
  const classes = useStyles();
  const [ticketFieldsSettingsExpanded, setTicketFieldsSettingsExpanded] = useState(true);
  const toggleTicketFieldsSettingsExpanded = () => {
    setTicketFieldsSettingsExpanded(!ticketFieldsSettingsExpanded);
  };

  return (
    <Grid
      container
      className={classes.panelRoot}
      data-testid="ticket-fields-panel"
    >
      <Accordion
        data-tag="ticketFieldSettings"
        expanded={ticketFieldsSettingsExpanded}
        TransitionProps={{
          unmountOnExit: true,
        }}
        className={classes.fullWidthAccordion}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={toggleTicketFieldsSettingsExpanded}
        >
          <Typography className={classes.heading}>
            {requestName}
          </Typography>
        </AccordionSummary>
        <div className={classes.ticketFieldsRow}>
          <div className={classes.ticketFieldsButtonContainer}>
            <Button
              className={clsx(["TicketFieldsBtn"])}
              data-testid="ticketfieldsBtn"
              variant="contained"
              fullWidth
              onClick={onTicketFieldsButtonClicked}
              color="primary"
            >
              {requestName} Ticket Fields
            </Button>
          </div>
          {showPayLaterToggle && (
            <div className={classes.payLaterToggleContainer}>
              <ValetAreaPayLaterSettings
                entityID={entityID}
                settingValues={settingValues}
                onPayLaterChanged={onPayLaterChanged}
              />
            </div>
          )}
        </div>
      </Accordion>
    </Grid>
  );
};

TicketFieldsSettingsForm.defaultProps = {
  requestType: 1,
  showPayLaterToggle: false,
};

TicketFieldsSettingsForm.propTypes = {
  requestType: PropTypes.number,
  onTicketFieldsButtonClicked: PropTypes.func.isRequired,
  entityID: PropTypes.string,
  settingValues: PropTypes.object,
  showPayLaterToggle: PropTypes.bool,
  onPayLaterChanged: PropTypes.func,
};

export default TicketFieldsSettingsForm;